import { render } from "./CreateWalletModal.vue?vue&type=template&id=0c11890c&scoped=true"
import script from "./CreateWalletModal.vue?vue&type=script&lang=js"
export * from "./CreateWalletModal.vue?vue&type=script&lang=js"

import "./CreateWalletModal.vue?vue&type=style&index=0&id=0c11890c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c11890c"]])

export default __exports__